import state from '@/store/state'

export getFileRef = (fileId, ext) =>
  throw 'Firebase Storage not initialized' unless state.storage
  path = state.uid + '/' + fileId
  if ext
    path = path + '.' + ext
  return state.storage.ref().child(path)
